export const LIGHT_HEX = {
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
  },
  rowing: {
    navy: '#0F172A',
    blue: '#1E40AF',
    sky: '#3B82F6',
    red: '#DC2626',
    green: '#16A34A',
    yellow: '#EAB308',
    crimson: '#991B1B',
  },
  surface: '#FFFFFF',
  heading: '#0F172A',
} as const;

export const TOKEN_CSS_VARS = {
  gray: {
    50: '--gray-50',
    100: '--gray-100',
    200: '--gray-200',
    300: '--gray-300',
    400: '--gray-400',
    500: '--gray-500',
    600: '--gray-600',
    700: '--gray-700',
    800: '--gray-800',
    900: '--gray-900',
  },
  surface: '--color-surface',
  heading: '--color-heading',
  brandNavy: '--color-brand-navy',
  chart: {
    axisTick: '--gray-500',
    axisLabel: '--gray-700',
    grid: '--chart-grid',
    tooltipBg: '--gray-900',
    tooltipFg: '--color-inverse',
    barTrack: '--chart-bar-track',
    barRange: '--chart-bar-range',
    barPercentile: '--chart-bar-percentile',
    overlayPeaks: '--chart-overlay-peaks',
    overlayDensity: '--chart-overlay-density',
  },
} as const;

export function rgbChannelsToHex(channels: string): string {
  const parts = channels.trim().split(/\s+/).map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) {
    throw new Error(`Invalid RGB channels: ${channels}`);
  }
  return `#${parts.map((n) => n.toString(16).padStart(2, '0')).join('')}`.toUpperCase();
}
